import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

import router from "@/router";
import store from "@/store";
import CustomMessage from "./custom-plugins/custom-message/CustomMessage.js";
import vPermission from "./directives/v-permission";
import formatters from "@/filters/formatters.js";
import { LoaderWindowPlugin } from "@/plugins/loader-window.js"; // Assuming this is your custom open window plugin
import { ImagePreviewerPlugin } from "@/components/image-previewer.js"; // Assuming this is your image previewer plugin
import { ImageCropperPlugin } from "@/components/image-cropper/image-cropper.js"; // Assuming this is your image cropper plugin

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import VueTypedJs from "vue-typed-js";
import "@/styles/element-variables.scss"; //自定义主题
import "font-awesome/css/font-awesome.css";
import "@/assets/styles/style.css";
import RegisterGlobalComponents from "./plugins/register-global-components.js"; // 全局组件注册
import SvgIcon from "@/components/SvgIcon.vue";
import "@/utils/stringUtils.js";
import ClickOutside from "element-ui/lib/utils/clickoutside";

Vue.use(ElementUI, { locale });
Vue.use(VueTypedJs);
Vue.use(CustomMessage);
Vue.component("SvgIcon", SvgIcon);
Vue.use(RegisterGlobalComponents);

Vue.use(VueRouter);
Vue.use(LoaderWindowPlugin);
Vue.use(ImagePreviewerPlugin);
Vue.use(ImageCropperPlugin);

Vue.config.productionTip = false;
Vue.directive("permission", vPermission);
Vue.directive("clickoutside", ClickOutside);
Object.entries(formatters).forEach(([name, fn]) => {
  Vue.filter(name, fn);
});

new Vue({
  el: "#app",
  router: router,
  store: store,
  // store,
  render: (h) => h(App),
});

console.log("Build Number:", process.env.VUE_APP_BUILD_NUMBER || "N/A");
